import "./styles/global-styles.scss";
function App() {
  return (
    <main className='ekblad__container'>
      <header className="ekblad__header">WEBSITE UNDER CONSTUCTION</header>
      <section className='ekblad__logo'></section>
      <footer className="ekblad__footer"><a href="mailto:studio@idaekbladstudio.no">STUDIO@IDAEKBLADSTUDIO.NO</a><br />
      <a href="https://www.instagram.com/idaekblad/" target="_blank" rel="noreferrer">INSTAGRAM</a></footer>
    </main>
  );
}

export default App;
